export interface IError {
  name: string;
  message: string;
}

export interface IErrors {
    storeName: string;
    errors: IError[];
}

const unknowError: IError = {
  name: 'Unknow',
  message: 'Unknow error, please refer to your system administrator.'
};

const errors: IErrors[] = [
  {
    storeName: 'userRoles',
    errors: [
      {
        name: 'ErrAlreadyExists',
        message: 'This user role already exists, please enter a different role name.'
      },
      {
        name: 'ErrInvalidObject',
        message:
          'This user role name contains forbidden characters, please use only letters, digits, dot or dash.'
      }
    ]
  },
  {
    storeName: 'userGroups',
    errors: [
      {
        name: 'ErrAlreadyExists',
        message: 'This user group already exists, please enter a different group name.'
      },
      {
        name: 'ErrInvalidObject',
        message:
          'This user group name contains forbidden characters, please use only letters, digits, dot or dash.'
      }
    ]
  }
];

export default function getErrorMessage(storeName: string, name: string): string {
  const storeErrors = errors.find((error: IErrors) => error.storeName === storeName);
  if (storeErrors) {
    const found = storeErrors.errors.find((error: IError) => error.name === name);
    return found ? found.message : unknowError.message;
  }
  return `Undefined store named ${storeName}, please refer to your system administrator.`;
}
